<template>
  <div class="bb-soa-balance"
       :style="{height: !isHidden ? heightContent : 0}"
  >
    <transition name="fade">
      <div class="bb-soa-balance__content"
           ref="bbBalance"
           v-if="display"
           :class="{'bb-soa-balance__content_hide': isHidden}"
      >
        <div v-for="soa in soas"
             :key="soa._id"
             class="bb-soa-balance-row"
        >
          <div class="bb-soa-balance-row__item-wrapper">
            <div class="bb-soa-balance-row__item">{{formatDate(soa.date)}}</div>
            <div class="bb-soa-balance-row__item"
                 v-if="soa.isShortfall"
            >
              <span class="bb-soa-balance-row-description"
                   v-html="setLinkToProforma(soa)"
                   @click="openProforma($event, soa)"
              />
              <BalanceLink :item="soa"
                           @openBalanceLink="openBalanceLink"
              />
            </div>
            <div class="bb-soa-balance-row__item"
                 v-else
            >
              {{soa.description}}
            </div>
          </div>
          <div class="bb-soa-balance-row__item bb-soa-balance-row__item_end">
            {{getReceivedORInvoiced(soa, 'invoiced')}}
          </div>
          <div class="bb-soa-balance-row__item bb-soa-balance-row__item_end">
            {{getReceivedORInvoiced(soa, 'received')}}
          </div>
          <div class="bb-soa-balance-row__item bb-soa-balance-row__item_end">{{getOutgoing(soa)}}</div>
          <div class="bb-soa-balance-row__item bb-soa-balance-row__item_end">{{getBalance(soa)}}</div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import {get} from 'lodash'
import convertNumber from '@/mixin/convertNumber'
import moment from 'moment'
import BalanceLink from '@/components/Dissemination/Sales/CRM/ContactCard/ContactSoa/TableBalance/BalanceLink'
export default {
  name: 'SoaBalance',
  components: {BalanceLink},
  props: ['row'],
  mixins: [convertNumber],
  computed: {
    soas: {
      get: function () {
        return get(this.row, 'soas', [])
      }
    },
    display () {
      return get(this.row, '$accordionContent', false)
    }
  },
  data () {
    return {
      heightContent: 'auto',
      isHidden: true
    }
  },
  methods: {
    formatDate (date) {
      return moment(date).format('DD-MMM-YYYY')
    },
    getOutgoing (soa) {
      const value = get(soa, 'outgoing', 0)
      return this.convertNumber(value)
    },
    getBalance (soa) {
      const value = get(soa, 'balance', 0)
      return this.convertNumber(value)
    },
    getReceivedORInvoiced (soa, prop) {
      const value = get(soa, prop, 0)
      return value !== 0 ? this.convertNumber(value) : '-'
    },
    setLinkToProforma (row) {
      const regexp = /No. BB-.+-\d+-\d+/gmi
      let { description } = row
      const invNumbers = description.match(regexp)
      if (invNumbers) {
        const invNo = `<span id="description__text"
                             class="bb-soa-balance-row-description__text">${invNumbers[0]}</span>`
        return description.replace(regexp, invNo)
      }
    },
    openProforma (event, soa) {
      this.$emit('openProforma', event, soa)
    },
    openBalanceLink (soa) {
      this.$emit('openBalanceLink', soa)
    },
    setOpen () {
      this.isHidden = !this.display
    },
    calcHeight () {
      const node = this.$refs.bbBalance
      this.heightContent = node ? node.offsetHeight + 'px' : 'auto'
      this.setOpen()
    }
  },
  watch: {
    display (newVal) {
      if (newVal) {
        this.$nextTick(this.calcHeight)
      } else {
        this.isHidden = true
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../../../../../sass/variables";
  @import "../../../../../../../sass/mixins";

  .bb-soa-balance {
    @include global-font;
    transition: 0.25s ease-out;

    &__content {
      background-color: $color-wild-sand;
      margin-top: 18px;
      margin-left: 15px;
      border-radius: 4px;
      padding: 19px 16px;
      margin-right: -16px;
      transition: 0.3s;

      &_hide {
        opacity: 0;
        z-index: -1;
        pointer-events: none;
      }
    }

    &-row {
      display: grid;
      align-items: center;
      grid-template-columns: 2fr repeat(4, minmax(61px, 152px));
      margin-bottom: 21px;

      &:last-child {
        margin-bottom: 0;
      }

      &__item-wrapper {
        display: grid;
        grid-template-columns: 116px 1fr;
      }

      &__item {
        font-weight: normal;
        font-size: 14px;
        line-height: 17px;
        text-transform: capitalize;

        &_center {
          text-align: center;
          margin-left: 10px;
        }

        &_end {
          text-align: end;
        }
      }
    }
  }

</style>
<style lang="scss">
  @import "../../../../../../../sass/variables";
  @import "../../../../../../../sass/mixins";

  .bb-soa-balance {
    &-row {
      &-description {
        &__text {
          color: $color-accent;
          cursor: pointer;

          &:hover {
            color: $color-accent-hover;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Dissemination/Sales/CRM/ContactCard/ContactSoa/TableBalance/SoaBalance.vue